/** Mentions — dedicated page reachable from Work sub-nav. */
import MentionsInbox from "@/components/app/MentionsInbox";

export default function Mentions() {
  return (
    <div className="max-w-3xl space-y-4" data-testid="mentions-page">
      <div className="st-page-header">
        <div>
          <div className="text-[11px] uppercase tracking-[0.18em] text-[color:var(--st-text-muted)]">Work</div>
          <h1 className="st-page-title">Mentions</h1>
          <div className="st-page-context">Every message that tagged you — across conversations you can see.</div>
        </div>
      </div>
      <MentionsInbox />
    </div>
  );
}
